import Keycloak from "keycloak-js";

const keycloakConfig = {
    url: process.env.REACT_APP_URL_KEYCLOACK,
    realm: process.env.REACT_APP_REALM_KEYCLOACK,
    clientId: process.env.REACT_APP_CLIENT_KEYCLOACK
   };

const KeycloakAuth = new Keycloak(keycloakConfig);


export default KeycloakAuth;